<template>
  <el-popover placement="right" width="260" trigger="hover">
    <div style="text-align: center; padding: 6px 0;">
      <img :src="author.avatar" style="width: 64px; height: 64px; border-radius: 50%;" />
      <p style="margin: 8px 0 4px; font-weight: bold;">{{ author.nickname }}</p>
      <p style="color: #0E7490; font-size: 13px;">{{ author.realstate == 3 ? '认证用户' : '未认证用户' }}</p>
      <p style="font-size: 12px; color: #888;">账号：{{ author.username }}</p>
      <p style="font-size: 12px; color: #888;">邮箱：{{ author.mail }}</p>
      <p style="font-size: 12px; color: #888;">QQ：{{ author.qq }}</p>
      <p style="font-size: 12px; color: #888; margin-top: 6px;">{{ author.synopsis }}</p>
      <el-button type="danger" size="mini" plain style="margin-top: 8px;" @click="report">举报</el-button>
    </div>
    <span slot="reference" style="color: #0E7490; cursor: pointer;">{{ author.nickname }}</span>
  </el-popover>
</template>

<script>
export default {
  name: 'AuthorPop',
  props: { author: { type: Object, default: () => ({}) } },
  methods: {
    report() {
      this.$router.push({ path: '/jubao', query: { user: this.author.username, url: window.location.href } })
    }
  }
}
</script>
